import "../DetailJob.scss";

const JobBulletList = ({ items = [] }) => {
  if (!items.length) return null;

  return (
    <ul className="job-bullet-list">
      {items.map((item, index) => (
        <li key={`${item}-${index}`}>
          <span className="job-bullet-text">{item}</span>
        </li>
      ))}
    </ul>
  );
};

export default JobBulletList;
